import Obstacle from './Obstacle';

const OFFSET_X = 10;

export default class Hole extends Obstacle {
  constructor({ game, player, values, road, collideItem, spikes }) {
    super({
      game,
      player,
      values,
      road,
      name: 'hole',
      collideItem,
      spikes,
    });
    this._chance = 0.009;
  }
  _deleteArea() {
    this.item.body.setSize(this._defaultWidth - (2 * OFFSET_X), this.defaultHeight, OFFSET_X, this._bodyOffsetY);
  }
}



// WEBPACK FOOTER //
// ./src/js/Hole.js